<template>
  <div id="app" >
    <navag v-if="istop"></navag>
    <router-view/>
    <footcom></footcom>
  </div>
</template>
<script>
import navag from '../src/components/Navag'
import footcom from '../src/components/Footer'
export default {
  components: {
    navag,footcom
  },
  data() {
    return {
      minheight:{minheight:'100px'},
      istop:1
    }
  },
  mounted() {
    var istop = this.$route.query.isTop;
    if(istop == 0){
         console.log(istop)
         this.istop = 0
    }
},
  // computed: {
  //   minHeight:function(){
  //       return document.documentElement.clientHeight
  //   }
  // },
}
</script>
<style lang="less">

</style>
